module.exports = __webpack_public_path__ + "img/shell_restaurant_sign.c92e306d.jpg";